import API from '.';
import serviceUrls from 'src/constants/serviceUrls';

export const login = (email, password) => {
  // Earlier semicolon ":" was used to separate email and password, 
  // but functionality breaks when ":" is used as separator in BE
  // so a pattern of characters is used as separator
  const basicAuth = ('Basic ' + btoa(email + '5394|_|R470R' + password)).trim();
  return API({
    headers: { authorization: basicAuth },
  })
    .post(serviceUrls.LOGIN_SERVICE, {})
    .then(res => ({ status: res.status, data: res.data }))
    .catch(res => res)
    .then(res => res);
};

export const ssologin = (stok) => {
  return API({
    headers: { sTok: stok },
  })
    .post(serviceUrls.LOGIN_SSO_SERVICE, {})
    .then(res => ({ status: res.status, data: res.data }))
    .catch(res => res)
    .then(res => res);
};

export const pinCodeRequest = (code, profileKey, flow) => {
  const serviceUrl = flow === 'forgot-password' ? serviceUrls.PINCODE_FORGOT_PASS_SERVICE : serviceUrls.PINCODE_SERVICE;
  return API({})
    .post(serviceUrl, { data: { code, profileKey } })
    .then(res => ({ status: res.status, data: res.data }))
    .catch(res => res)
    .then(res => res);
};

export const forgotPassword = email => {
  return API({})
    .post(serviceUrls.FORGOT_PASSWORD_SERVICE, { data: { Email: email } })
    .then(res => res.data)
    .catch(res => res)
    .then(res => res);
};

export const resendCode = (email, profileKey) => {
  return API({})
    .post(serviceUrls.RESEND_CODE_SERVICE, { data: { Email: email, profileKey: profileKey } })
    .then(res => res.data)
    .catch(res => res)
    .then(res => res);
};

export const resetPassword = (authCode, password, profileKey) => {
  return API({})
    .post(serviceUrls.RESET_PASS_SERVICE, { data: { authCode, newPassword: password, profileKey } })
    .then(res => res.data)
    .catch(res => res)
    .then(res => res);
};

export const userLogout = token => {
  return API({
    headers: { token },
  })
    .post(serviceUrls.LOGOUT_SERVICE, {})
    .then(res => res)
    .catch(res => res)
    .then(res => res);
};
